<template>
    <div class="aset__filters-container">

        <!-- all -->
        <div class="px-6 pt-6">
            <router-link tag="span" class="flex cursor-pointer" :class="{'text-primary': asetFilter == 'all'}" :to="`${baseUrl}/${asetTaxonomy}/all`">
                <feather-icon icon="LayersIcon" :svgClasses="[{'text-primary stroke-current': asetFilter == 'all'}, 'h-6 w-6']"></feather-icon>
                <span class="text-lg ml-3">All</span>
            </router-link>
        </div>

        <vs-divider></vs-divider>

        <!-- starred -->
        <div class="px-6 py-4">
            <div class="flex items-center flex-wrap justify-between mb-6">
                <div class="flex items-center">
                  <h5>Kategori</h5>
                </div>
            </div>
            <template v-for="kategori in asetKategoris">
              <router-link tag="span" class="flex mb-2 cursor-pointer" :to="`${baseUrl}/${asetTaxonomy}/${kategori.slug}`" :key="kategori.slug">
                <div class="ml-1 h-3 w-3 rounded-full mr-4 mt-2" :class="'border-2 border-solid border-primary'" />
                <span class="text-lg" :class="{'text-primary': asetFilter == kategori.slug}">{{ kategori.name }}</span>
              </router-link>
            </template>
        </div>

        <vs-divider></vs-divider>

        <div class="px-6 py-4">
          <div class="flex items-center flex-wrap justify-between">
              <div class="flex items-center">
                <h5>Tag</h5>
              </div>
              <div class="flex">
                  <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="activePromptTags = true" />
              </div>
          </div>
          <div class="aset__lables-list">
              <router-link tag="span" class="aset__label flex items-center mt-6 cursor-pointer" v-for="(tag, index) in asetTags" :key="index" :to="`${baseUrl}/${taxonomy}/${tag.slug}`">
                  <div class="ml-1 h-3 w-3 rounded-full mr-4" :class="'border-2 border-solid border-' + tag.color" />
                  <span class="text-lg" :class="{'text-primary': asetFilter == tag.slug}">{{ tag.name }}</span>
              </router-link>
          </div>
        </div>

        <vs-prompt
        title="Add Tag"
        accept-text= "Submit"
        button-cancel = "border"
        @cancel="clearTag"
        @accept="submitTag"
        @close="clearTag"
        :is-valid="validateTag"
        :active.sync="activePromptTags">
          <div>
            <form>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <vs-input name="title" class="w-full mb-4 mt-5" placeholder="Title" v-model="dataTag" />
                  <vs-select
                    class="w-full"
                    label="Color"
                    v-model="dataColor"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in dataColorx"/>
                  </vs-select>
                </div>
              </div>

            </form>
          </div>
        </vs-prompt>

        <vs-divider></vs-divider>
        
        <div class="px-6 py-4">
          <h5>Range Aset</h5>
          <div class="pl-4 mt-6">
            <vue-range-slider 
              v-model="rangeTotal" 
              :min="minRange" :max="maxRange" 
              :tooltip-merge="tooltipMerge"
              :enable-cross="enableCross"
              tooltip-dir="left">
            </vue-range-slider>
          </div>
          <vs-button color="#3498db" type="border" icon-pack="feather" icon="icon-arrow-right" size="" class="w-full mt-4" @click="rangeData">Submit</vs-button>
        </div>

    </div>
</template>
  
<script>
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
export default{
  components: {
    VueRangeSlider 
  },
  props: {
    asetFilter: {
      type: String,
      required: true
    },
    maxRange: {
      type: Number,
      required: true
    },
    Search: {
      type: String,
    }
  },
  data () {
    return {
      minRange: 0,
      rangeTotal: [0,this.maxRange],
      enableCross: false,
      tooltipMerge: false,
      formatter: value => `￥${value}`,

      activePromptTags: false,
      dataTag: null,
      dataColor: 'pilih',
      dataColorx: ['primary', 'success', 'danger', 'warning', 'dark'],
      asetFilters: [
        { filterName: 'Transfer', filter: 'transfer', icon: 'CodeIcon', color:'text-warning' },
        { filterName: 'Penerimaan', filter: 'penerimaan', icon: 'ArrowUpIcon', color:'text-success' },
        { filterName: 'Pengeluaran', filter: 'pengeluaran', icon: 'ArrowDownIcon', color:'text-danger' }
      ]
    }
  },
  computed: {
    validateTag () {
      return !this.errors.any() && this.dataTag && this.dataColor != 'pilih'
    },
    asetTaxonomy () {
      return this.$route.params.taxonomy
    },
    asetTags () {
      return this.$store.state.aset.tags
    },
    asetKategoris () {
      return this.$store.state.aset.terms
    },
    validateAccount () {
      return !this.errors.any() && this.dataAccount && this.dataColor != 'pilih'
    },
    akuns () {
      return this.$store.state.akun.akungroups
    },
    taxonomy () {
      return 'tag-aset-tetap'
    },
    /*
    asetFilter () {
      return this.$route.params.filter
    },
    */
    baseUrl () {
      const path = this.$route.path
      const paths = path.slice(0, path.lastIndexOf('/'))
      return paths.slice(0, paths.lastIndexOf('/'))
    }
  },
  methods: {
    clearTag () {
      this.dataTag = null
      this.dataColor = 'pilih'
    },
    submitTag () {
      this.$vs.loading()
      const obj = {
        name: this.dataTag,
        term_group: 0,
        parent: 0,

        meta : {
          color: this.dataColor
        },

        taxonomy: 'tag-aset-tetap'
      }

      this.$store.dispatch('aset/addTag', obj)
      .then((response) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Berhasil',
          color  : 'success',
          text  : response.message,
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      this.clearTag()
      this.activePromptTags = false
    },
    rangeData () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#aset-load',
        type: 'sound',
        scale: 0.5
      })
      this.$store.commit('aset/UPDATE_ASET_FILTER', this.$route.params.filter)
      let obj = {
        taxonomy: this.$route.params.taxonomy,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.aset.state_range
      }
      this.$store.commit('aset/SET_NULL_TASKS')
      this.$store.commit('aset/SET_RANGE', this.rangeTotal)
      this.$store.dispatch('aset/fetchAset', obj)
      setTimeout(() => {
        this.$vs.loading.close('#aset-load > .con-vs-loading')
      }, 3000)
    }
  },
  created () {
    VueRangeSlider.methods.handleKeyup = ()=> console.log;
    VueRangeSlider.methods.handleKeydown = ()=> console.log;
  }
}
</script>